import * as React from 'react';
import BttfAxios from '@features/utils/axios';
import Select from 'react-select/lib/Creatable';
import ICollaboratorsSearch, { ICollaboratorsSearchValues, TCollaboratorsSearch, IData } from './ICollaboratorsSearch';
import { components } from 'react-select';
import { isEmail } from '@features/utils/functions';
import AsyncImage from '@appComponents/AsyncImage/AsyncImage';
import noPhotoMale from '@images/no_photo_male.png';

import * as style from './CollaboratorSearchStyles.module.scss'

export default class CollaboratorsSearch extends React.Component<ICollaboratorsSearch, TCollaboratorsSearch> {

  state:TCollaboratorsSearch = {
    data: [],
    selected: [],
    showBtn: false,
    isLoading: false,
  };

  getValue = (value: string) => {
    if (value.length > 2) {
      this.setState({ isLoading: true });
      BttfAxios.get(`/api/search/profiles?q=${value}`, (res) => {
        const data = res.data.map((elem: IData) => {
          elem.value = elem.slug;
          elem.label = elem.name || '-';

          return elem;
        });
        this.setState({ data: data, isLoading: false });
      });
    }
  }

  getAllValues = (all: ICollaboratorsSearchValues[]) => {
    if (all.length > 0) {
      all.forEach((elem) => {
        if (isEmail(elem.value)) elem.isEmail = true;
      });
      this.setState({ showBtn: true, selected: all });
    } else this.setState({ showBtn: false, selected: all });
  }

  validate(inputValue: string, selectedValue: ICollaboratorsSearchValues[]) {
    if (isEmail(inputValue)) return true;
    return false;
  }

  optionCustomize(props: { data: IData; [key: string]: string | {} }) {
    return (
      <div className={style.optionHolder}>
        <AsyncImage image={props.data.avatar} fallback={noPhotoMale}>
          <img
            alt=""
            className={style.optionHolderImg}
          />
        </AsyncImage>
        <components.Option {...props}/>
      </div>
    );
  }

  invitePeople = () => {
    this.props.invitePeople(this.state.selected);
    this.setState({ showBtn: false, selected: [null], data: [] });
  }

  render() {
    return (
      <div className={style.collaboratorsSearch}>
        <h2>Invite Team Members</h2>
        <p>On this page you can add people to your Pitch Team. These people will have full access
        to the pitch to make updates, answer questions and promote your pitch. You can invite existing
        BF users or invite your team members by email.
        </p>
        <div className={style.selectHolder}>
          <p className={style.selectHolderP}>User name or email</p>
          <Select
            options={this.state.data}
            isMulti={true}
            value={this.state.selected}
            onChange={this.getAllValues}
            onInputChange={this.getValue}
            isValidNewOption={this.validate}
            isLoading={this.state.isLoading}
            components={{ Option: this.optionCustomize }}
            filterOption={() => (true)}
            styles={{ option: (base: CSSRule) => ({ ...base, paddingLeft: '50px' }) }}
            formatCreateLabel={(data: string) => <div>Add <strong>{data}</strong></div>}
          />
        </div>
        {this.state.showBtn &&
          <button onClick={this.invitePeople} className={style.inviteBtn}>Invite selected people</button>}
      </div>
    );
  }
}
